<template>
  <b-modal
    :visible="visible"
    title="И-баримт хэвлэх"
    size="lg"
    centered
    no-close-on-backdrop
    @hidden="onHidden"
  >
    <!-- Хайлт -->
    <b-row class="mb-2">
      <b-col cols="5">
        <label>Утасны дугаар</label>
        <b-form-input
          v-model="phone"
          placeholder="99119911"
        />
      </b-col>
      <b-col cols="5">
        <label>Огноо</label>
        <flat-pickr
          v-model="transactionDate"
          class="form-control"
          :config="{ dateFormat: 'Y-m-d' }"
        />
      </b-col>
      <b-col cols="2" class="d-flex align-items-end">
        <b-button
          variant="primary"
          block
          :disabled="!phone"
          @click="searchCustomer"
        >
          Хайх
        </b-button>
      </b-col>
    </b-row>

    <!-- Хэрэглэгчийн мэдээлэл -->
    <div v-if="customer">
      <hr />
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Овог:</b-col>
        <b-col cols="8">{{ customer.lastname }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Нэр:</b-col>
        <b-col cols="8">{{ customer.firstname }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Имэйл:</b-col>
        <b-col cols="8">{{ customer.email }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Утас:</b-col>
        <b-col cols="8">{{ customer.phone_number }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Регистрийн дугаар:</b-col>
        <b-col cols="8">{{ customer.register_number }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">НӨАТ төрөл:</b-col>
        <b-col cols="8">{{ customer.ebarimt_vat_type }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">И-баримт регистр:</b-col>
        <b-col cols="8">{{ customer.ebarimt_register }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Огноо:</b-col>
        <b-col cols="8">{{ customer.created_date }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col cols="4" class="font-weight-bold">Нийт дүн:</b-col>
        <b-col cols="8">
          <b-form-input
            v-model="totalAmount"
            type="number"
            readonly
          />
        </b-col>
      </b-row>
    </div>

    <!-- Footer -->
    <template #modal-footer>
      <b-button variant="secondary" @click="onHidden">
        Хаах
      </b-button>
      <b-button
        variant="success"
        :disabled="!customer"
        @click="printReceipt"
      >
        Хэвлэх
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BButton, BFormInput,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store'
import { formatCurrency } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BButton,
    BFormInput,
    flatPickr,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      phone: '',
      transactionDate: new Date().toISOString().substring(0, 10),
      customer: null,
      totalAmount: '',
    }
  },
  methods: {
    formatCurrency,
    searchCustomer() {
      store
        .dispatch('app-ebarimt/getCustomerSummary', {
          phone: this.phone,
          transaction_date: this.transactionDate,
        })
        .then(response => {
          const data = response.data
          if (data && data.customer_id) {
            this.customer = data
            this.totalAmount = data.total_amount * -1
          } else {
            this.customer = null
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Хэрэглэгч олдсонгүй',
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            })
          }
        })
        .catch(() => {
          this.customer = null
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Хэрэглэгч хайхад алдаа гарлаа',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    printReceipt() {
      store
        .dispatch('app-ebarimt/generateReceipt', {
          customer_id: this.customer.customer_id,
          transaction_date: this.transactionDate,
        })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'И-баримт амжилттай хэвлэгдлээ',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$emit('printed')
          this.onHidden()
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'И-баримт хэвлэхэд алдаа гарлаа',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    onHidden() {
      this.phone = ''
      this.transactionDate = new Date().toISOString().substring(0, 10)
      this.customer = null
      this.totalAmount = ''
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
